import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Create LastLocation context
const LastLocationContext = createContext(null);

// Provider component to track the last location
export const LastLocationProvider = ({ children }) => {
    const location = useLocation();
    const [lastLocation, setLastLocation] = useState(null);

    useEffect(() => {
        setLastLocation(location);
    }, [location]);

    return <LastLocationContext.Provider value={lastLocation}>{children}</LastLocationContext.Provider>;
};

// Hook to use last location
export function useLastLocation() {
    return useContext(LastLocationContext);
}
